<template>
  <InputWithLabel
      type="text"
      name="anotherLastName"
      :errors="v$.anotherLastName.$errors"
      v-model="anotherLastName"
      @blur="v$.anotherLastName.$touch"
      scroll-into-view-if-errors
  >
    Фамилия страхователя*
  </InputWithLabel>

  <InputWithLabel
      type="text"
      name="anotherName"
      :errors="v$.anotherName.$errors"
      v-model="anotherName"
      @blur="v$.anotherName.$touch"
      scroll-into-view-if-errors
  >
    Имя страхователя*
  </InputWithLabel>

  <InputWithLabel
      type="text"
      name="anotherPatronymic"
      :errors="v$.anotherPatronymic.$errors"
      v-model="anotherPatronymic"
      @blur="v$.anotherPatronymic.$touch"
      :hints="['Если отчество отсутствует, то укажите \'Нет\'.']"
      scroll-into-view-if-errors
  >
    Отчество страхователя*
  </InputWithLabel>


  <InputWithLabel
      type="tel"
      name="telephone"
      mask="+7 (999) 999-99-99"
      :errors="v$.telephone.$errors"
      v-model="telephone"
      @blur="v$.telephone.$touch"
      scroll-into-view-if-errors
  >
    Номер мобильного телефона страхователя*
  </InputWithLabel>

  <InputWithLabel
      type="email"
      name="email"
      :errors="v$.email.$errors"
      v-model="email"
      @blur="v$.email.$touch"
      scroll-into-view-if-errors
  >
    Адрес электронной почты*
  </InputWithLabel>
</template>

<script>
import * as mns from "@/store/mutation-types";
import useVuelidate from "@vuelidate/core";
import {email, helpers, required} from "@vuelidate/validators";
import {russiaNumber} from "@/validators/telephone-validators";
import InputWithLabel from "@/components/utils/InputWithLabel";


export default {
  anotherNameLife: "AnotherPersonInsurer",
  components: {InputWithLabel},
  data(){
    return {
      v$: useVuelidate(),
    };
  },
  validations(){
    return {
      anotherLastName: {
        required: helpers.withMessage('Поле должно быть заполнено', required)
      },
      anotherName: {
        required: helpers.withMessage('Поле должно быть заполнено', required)
      },
      anotherPatronymic: {
        required: helpers.withMessage('Поле должно быть заполнено', required)
      },
      telephone: {
        russiaNumber: helpers.withMessage('Неверный формат', russiaNumber)
      },
      email: {
        required: helpers.withMessage('Поле должно быть заполнено', required),
        email: helpers.withMessage('Неверный формат', email),
      },
    }
  },
  computed: {
    anotherLastName: {
      get(){
        return this.$store.getters.anotherLastName;
      },
      set(value){
        this.$store.commit(mns.SET_ANOTHER_LAST_NAME, value)
      }
    },
    anotherName: {
      get(){
        return this.$store.getters.anotherName;
      },
      set(value){
        this.$store.commit(mns.SET_ANOTHER_NAME, value)
      }
    },
    anotherPatronymic: {
      get(){
        return this.$store.getters.anotherPatronymic;
      },
      set(value){
        this.$store.commit(mns.SET_ANOTHER_PATRONYMIC, value)
      }
    },
    telephone: {
      get(){
        return this.$store.getters.telephone;
      },
      set(value){
        this.$store.commit(mns.SET_TELEPHONE, value)
      }
    },
    email: {
      get(){
        return this.$store.getters.email;
      },
      set(value){
        this.$store.commit(mns.SET_EMAIL, value)
      }
    },
  }
}
</script>

<style scoped>

</style>